import { ContentHeader } from "../../components";
import { Form, Button, Input, Row, Col, Table, Space, InputNumber} from 'antd';
import { DeleteOutlined, SaveOutlined, EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import Column from 'antd/es/table/Column';
import { layDanhMucLoaiHopDong, luuLoaiHopDong, xoaLoaiHopDong } from "@app/services/danhmuc";
import ModalTextForm from "@app/components/modal/ModalTextForm";
import { toast } from "react-toastify";
import { validateMessages } from '../../helpers/common';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useDispatch } from 'react-redux';
import { LoaiHopDong } from "../../models/hopdong/HopDong";
import { searchLength } from "../../constants";

const QuanLyLoaiHopDong = () => {
    const [data, setData] = useState<Array<LoaiHopDong>>([]);
    const [page, setPage] = useState(1);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState<boolean>(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const setFormDetailModal = (value: LoaiHopDong | null) => {
        form.setFieldsValue({
            "id": value?.id,
            "ten": value?.ten || "",
            "thuTu": value?.thuTu || 0
        });
        setShowModalChiTiet(true);
    }

    const layDuLieu = async () => {
        try {
            setIsLoadingTable(true);
            let rs = await layDanhMucLoaiHopDong();
            setData(rs);
            setIsLoadingTable(false);
        } catch (error: any) {
            setIsLoadingTable(false);
        };
    }

    const onDelete = async () => {
        try {
            setIsLoadingBtn(true);
            await xoaLoaiHopDong(idXoa);
            toast.success('Xoá loại hợp đồng/QĐ bổ nhiệm thành công!');

            // Tính toán số trang mới sau khi xóa
            const totalRecords = data.length - 1; // Số lượng bản ghi sau khi xóa
            let newPage = page;

            if (newPage > Math.ceil(totalRecords / searchLength)) {
                // Nếu trang hiện tại lớn hơn số trang mới tối đa
                newPage = Math.ceil(totalRecords / searchLength);
            }

            setPage(newPage);
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setReloadPage(true);
        setIsLoadingBtn(false);
    }

    const onFinish = async (values: any) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoadingBtn(true);
            await luuLoaiHopDong(values);
            setShowModalChiTiet(false);
            toast.success('Lưu thông tin loại hợp đồng/QĐ bổ nhiệm thành công!')
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        dispatch(hideLoadingScreen());
        setIsLoadingBtn(false);
        setReloadPage(true);
    };

    useEffect(() => {
        if (reloadPage) {
            layDuLieu();
            setReloadPage(false);
        }
    }, [reloadPage]);

    return (<section>
        <ContentHeader title="Quản lý danh mục loại hợp đồng/QĐ bổ nhiệm" />
        {idXoa > 0 && <ModalTextForm show={idXoa > 0}
            title="Xoá loại hợp đồng/QĐ bổ nhiệm"
            handleClose={() => setIdXoa(0)}
            handleSave={onDelete}>
            Xác nhận xóa loại hợp đồng/QĐ bổ nhiệm đang chọn
        </ModalTextForm>}
        {showModalChiTiet && <ModalTextForm title="Quản lý loại hợp đồng/QĐ bổ nhiệm "
            hideFooter
            show={showModalChiTiet}
            handleClose={() => setShowModalChiTiet(false)}
        >
            <Form
                layout="vertical"
                validateMessages={validateMessages}
                onFinish={onFinish}
                form={form}
            >
                <Form.Item hidden name="id"><Input /></Form.Item>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Tên loại hợp đồng/QĐ bổ nhiệm"
                            name="ten"
                            rules={[{ required: true, message: 'Vui lòng nhập tên loại hợp đồng/QĐ bổ nhiệm' }]}
                        >
                            <Input placeholder="Tên loại hợp đồng/QĐ bổ nhiệm"/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Thứ tự"
                            name="thuTu" >
                            <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button type="primary" loading={isLoadingBtn} className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                        Lưu
                    </Button>
                </Form.Item>
            </Form>
        </ModalTextForm>}
        <Row className="form-group" gutter={8}>
            <Col span={8}>
                <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên loại hợp đồng/QĐ bổ nhiệm để tìm kiếm" onChange={(e) => {setPage(1); setTuKhoa(e.target.value)}} />
            </Col>
            <Col span={16}>
                <Button
                    className="hrm-btn hrm-btn-warning float-right"
                    onClick={() => {
                        setFormDetailModal(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span={24}>
                <div className="card card-primary">
                    <Row>
                        <Col span={24}>
                            <Table
                                loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={data.map((item: any, index) => { item.key = index; return item; }).filter((record: LoaiHopDong) =>
                                    (record.ten.toLowerCase().includes(tuKhoa.toLowerCase()))
                                )}
                                rowClassName={(record, index) => {
                                    return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                }}
                                pagination={{
                                    current: page,
                                    onChange: (page, pageSize) => {
                                        setPage(page);
                                    },
                                }}
                            >
                                <Column
                                    width="5%"
                                    title="STT"
                                    key="STT"
                                    render={(value, record, index) =>
                                    (
                                        <span key={"stt" + index}>
                                            {(page - 1) * searchLength + index + 1}
                                        </span>
                                    )
                                    }
                                />
                                <Column width="78%" title="Tên loại hợp đồng/QĐ bổ nhiệm" dataIndex="ten" key="ten" />
                                <Column title="Thứ tự" dataIndex="thuTu" key="thuTu" />
                                <Column
                                    title=""
                                    key="action"
                                    render={(value, record, index) =>
                                    (
                                        <Space>
                                            <Button type="primary" size={"small"} title="Sửa"
                                                icon=<EditOutlined rev="" />
                                                onClick={() =>{ setFormDetailModal(value); }}
                                            >
                                                Sửa
                                            </Button>
                                            <Button type="primary" danger size={"small"} title="Xóa"
                                                onClick={() => { setIdXoa(value.id) }}
                                                icon=<DeleteOutlined rev="" />
                                            >
                                                Xóa
                                            </Button>
                                        </Space>
                                    )
                                    }
                                />
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </section>
    );
}
export default QuanLyLoaiHopDong;